import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form, Button } from 'reactstrap';

//import Components
//import SearchOption from '../Components/Common/SearchOption';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import OutletDropdown from '../Components/Common/OutletDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import Briefing from '../Components/Common/Briefing';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;

        if (windowSize > 767)
            document.querySelector(".hamburger-icon").classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        const sidebarSize = document.documentElement.getAttribute('data-sidebar-size');
        const collapsedSidebarSizes = ['sm', 'sm-hover', 'sm-hover-active', 'md'];
        const toggleVerticalSidebarSize = () => {
          if (collapsedSidebarSizes.includes(sidebarSize)) {
            document.documentElement.setAttribute("data-sidebar-size", "lg");
          } else {
            document.documentElement.setAttribute("data-sidebar-size", "sm");
          }
        };

        //For collapse vertical menu
        if (document.documentElement.getAttribute('data-layout') === "vertical") {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                toggleVerticalSidebarSize();
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                toggleVerticalSidebarSize();
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };
    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <h4 className="text-dark logo">{process.env.REACT_APP_SMALL_NAME}</h4>
                                    </span>
                                    <span className="logo-lg">
                                        <h4 className="text-dark logo">{process.env.REACT_APP_NAME}</h4>
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <h4 className="text-white logo">{process.env.REACT_APP_SMALL_NAME}</h4>
                                    </span>
                                    <span className="logo-lg">
                                        <h4 className="text-white logo">{process.env.REACT_APP_NAME}</h4>
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>

                        </div>

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* Briefing */}
                            <Briefing />
                          {/* <div className="me-5 pe-3 header-item d-none d-sm-flex">
                       <a
                    // onClick={toggleFullscreen}
                    href='https://e2y2p.share.hsforms.com/2N2sPz_eRQ8-7xu1lbkvRWw'
                    target='blank'
                         type="button"
                      className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                      >   
                    <img src='/customer-service-help-svgrepo-com-t.svg' style={{height:'60px', width:'200px'}}/>
                 </a>
                </div> */}
                            <div className="d-flex align-items-center">
                            <a href="https://e2y2p.share.hsforms.com/2N2sPz_eRQ8-7xu1lbkvRWw" target="_blank" rel="noreferrer">
                                <Button className="bg-primary">
                                <span className="fs-14"><i className="pt-1 ri-customer-service-fill"></i> Support</span>
                                </Button>
                            </a>
                            </div>
                           
                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* OutletDropdown */}
                            <OutletDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;